import { c as _c } from "react/compiler-runtime";
import { Slider } from "@/components/ui/slider";
type Props = {
  onChange: (km: number) => void;
  value: number;
  label?: string;
  maxKm?: number;
  defaultValue?: number;
};
export default function KilometerSlider(props) {
  const $ = _c(19);
  let t0;
  if ($[0] !== props.label) {
    t0 = props.label && <label>{props.label}</label>;
    $[0] = props.label;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== props.defaultValue) {
    t1 = props.defaultValue ? [props.defaultValue] : [100];
    $[2] = props.defaultValue;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== props) {
    t2 = val => {
      props.onChange(val[0]);
    };
    $[4] = props;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== props.value) {
    t3 = [props.value];
    $[6] = props.value;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const t4 = props.maxKm ?? 100;
  let t5;
  if ($[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
    t5 = <Slider className="my-4" defaultValue={t1} onValueChange={t2} value={t3} step={5} max={t4} min={5} />;
    $[8] = t1;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== props.value) {
    t6 = <div className="text-sm">{props.value} km</div>;
    $[13] = props.value;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t0 || $[16] !== t5 || $[17] !== t6) {
    t7 = <div>{t0}{t5}{t6}</div>;
    $[15] = t0;
    $[16] = t5;
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  return t7;
}